import { useState } from "react";
import SubmittedTestsReportModal from "@modals/SubmittedTestsReportModal";
import "@style/Admin.scss";

const SUBMITTED_TESTS = "submitted-tests";

const COMPANY_REPORTS = [
  {
    id: SUBMITTED_TESTS,
    name: "Submitted Tests",
    description: "Tests submitted in a date range, including department, job title, and supervisor when those fields were collected.",
  },
];

export default function CompanyReportsTab(props: { tabData: any }) {
  const { company, updateSpinner, activeTab } = props.tabData ?? {};
  const [selectedReportId, setSelectedReportId] = useState<string>(SUBMITTED_TESTS);
  const [showCreateModal, setShowCreateModal] = useState(false);

  if (activeTab !== "reports") return null;

  function onCreate() {
    if (selectedReportId !== SUBMITTED_TESTS) return;
    setShowCreateModal(true);
  }

  return (
    <div className={activeTab === "reports" ? "adminTabContent active" : "adminTabContent"}>
      <div className="companyReportsTab">
        <div className="tableWrapper dimensionTable">
          <table className="horizontal">
            <caption>
              <span className="title">Reports</span>
            </caption>
            <thead>
              <tr>
                <th className="wideNameHeader">Name</th>
                <th>Description</th>
              </tr>
            </thead>
            <tbody>
              {COMPANY_REPORTS.map((report) => (
                <tr
                  key={report.id}
                  className={selectedReportId === report.id ? "active" : ""}
                  onClick={() => setSelectedReportId(report.id)}
                >
                  <td>{report.name}</td>
                  <td>{report.description}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="companyReportsActions">
          <button
            type="button"
            className="btn btn-primary"
            onClick={onCreate}
            disabled={!selectedReportId}
          >
            Create
          </button>
        </div>
      </div>

      <SubmittedTestsReportModal
        isOpen={showCreateModal}
        companyId={company?.id}
        onClose={() => setShowCreateModal(false)}
        updateSpinner={updateSpinner}
      />
    </div>
  );
}
